import React, { useState } from "react"
import PropTypes from "prop-types"
import Wrapper from "components/sections/wrapper"
import Card from "./card"
import "./sectionTeamTestimonial.scss"
import useMediaQuery from "utils/useMediaQuery"
const SectionTeamTestimonial = ({ contentTitle, teamTestimonials }) => {
  const [showAll, setShowAll] = useState(false)
  const isMobile = useMediaQuery("(max-width: 768px)")

  const visibleTestimonials =
    isMobile && !showAll ? teamTestimonials.slice(0, 2) : teamTestimonials

  return (
    <div className="team-testimonial">
      {contentTitle && (
        <Wrapper {...contentTitle} className="careers-heading-wrapper" />
      )}

      <div className="team-testimonial__cards">
        {visibleTestimonials.map((testimonial, i) => (
          <Card key={i} {...testimonial} />
        ))}
      </div>

      {isMobile && teamTestimonials.length > 2 && (
        <div className="team-testimonial__toggle">
          <button onClick={() => setShowAll(!showAll)}>
            {showAll ? "Show Less" : "See More Reviews"}
          </button>
        </div>
      )}
    </div>
  )
}

SectionTeamTestimonial.propTypes = {
  contentTitle: PropTypes.object,
  teamTestimonials: PropTypes.arrayOf(PropTypes.object),
}

export default SectionTeamTestimonial
